<script setup>
import { ref, onMounted, computed } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useRequestsStore } from "@/stores/storeRequests";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { Pagination } from "swiper/modules";

const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();

const partners = ref([
{
    "id": 2,
    "logo":new URL("@/assets/img/stub_2.png", import.meta.url).href,
    "url": "https://ozon.ru"
}
]);

const isMobile = computed(() => storeSettings.widthWindow <= 576);

onMounted(async () => {
	partners.value = await storeRequests.getPartners();
	
});
</script>
<template>
	<section class="partners section" id="partners" >
		<div class="container">
			<h2 class="partners__title title2">Где купить</h2>
			<div class="partners__slider" v-if="partners.length">
				<Swiper
					v-if="isMobile"
					:modules="[Pagination]"
					:observer="true"
					:observeParents="true"
					:observeSlideChildren="true"
					:resizeObserver="true"
					:pagination="{
						el: '.pagination',
					}"
					:breakpoints="{
						320: {
							slidesPerView: 1,
							spaceBetween: 15,
						},
						481: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						577: {
							slidesPerView: 1.7,
							spaceBetween: 50,
						}
					}"
					class="partners__swiper"
				>
					<SwiperSlide :class="['partners-slide']" v-for="partner in partners" :key="partner.id">
						<a :href="partner.url" target="_blank" rel="noopener noreferrer" class="partners-slide__link">
							<img class="full-img" width="387" height="140" :src="partner.logo" alt="img" />
						</a>
					</SwiperSlide>
					<div class="partners__pagination pagination"></div>
				</Swiper>
				<div class="partners__grid" v-else>
					<a :href="partner.url" target="_blank" rel="noopener noreferrer" class="partners-slide__link" v-for="partner in partners" :key="partner.id">
						<img class="full-img" width="387" height="140" :src="partner.logo" alt="img" />
					</a>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
@use "@/assets/scss/blocks/swiper";

.partners {
	position: relative;
	&::before {
		position: absolute;
		content: "";
		background-image: url("@/assets/img/partners_bg.webp");
		background-repeat: no-repeat;
		background-size: contain; /* w h*/
		width: 29rem;
		height: 77rem;
		top: -57%;
		right: 0%;
		@media (max-width: vars.$t) {
			width: 15rem;
			height: 42rem;
			top: -10%;
		}
		@media (max-width: vars.$x480) {
			display: none;
		}
	}
}
.partners__title {
	@media (max-width: vars.$xx) {
		margin-bottom: 3.3rem;
	}
}
.partners__slider {
	position: relative;
}
.partners__swiper {
}
.partners-slide__link {
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--system-fill-light);
	border: 1px solid rgba(14, 14, 14, 0.16);
	border-radius: var(--border-radius);
	@media (max-width: vars.$xx) {
		height: 14rem;
	}
	@media (hover: hover) {
		&:hover {
			img {
				transform: scale(1.02);
			}
		}
	}
	img {
		width: 100%;
		height: 100%;
		transition: transform var(--transition) ease-in;
	}
}
.partners__grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-auto-rows: 14rem;
	gap: 2.4rem;
	@media (max-width: vars.$mn) {
		grid-auto-rows: 10rem;
		gap: 1.6rem;
	}
}
.partners__pagination {
	display: none;
	margin-top: 2.4rem;
	@media (max-width: vars.$m) {
		display: flex;
	}
}
</style>
